import React, { useState } from 'react';
import { Edit, SimpleForm, TextInput, FileInput, ImageField, useUpdate, useNotify, useRedirect, required } from 'react-admin';
import { uploadImage } from '../../../config/services/strapi/strapi';

function TarjetasInicioEdit(props: any) {
  const [portadaChanged, setPortadaChanged] = useState(false);
  const [videoChanged, setVideoChanged] = useState(false);
  const [update] = useUpdate();
  const notify = useNotify();
  const redirect = useRedirect();
  const resourceName = 'plg-tarjetas-inicios';

  const handleSubmit = async (data: any) => {
    const token = localStorage.getItem('strapi_jwt');
    const payload: Record<string, any> = { titulo: data.titulo };

    if (portadaChanged && data.portada?.rawFile) {
      const up = await uploadImage(data.portada.rawFile, token!);
      payload.portada = { id: up.id };
    }
    if (videoChanged && data.video?.rawFile) {
      const up = await uploadImage(data.video.rawFile, token!);
      payload.video = { id: up.id };
    }

    update(resourceName, { id: data.id, data: payload }, {
      onSuccess: () => {
        notify('Actualizado');
        redirect('list', resourceName);
      }
    });
  };

  return (
    <Edit {...props}>
      <SimpleForm onSubmit={handleSubmit}>
        <TextInput source="titulo" validate={[required()]} fullWidth />
        
        <FileInput source="portada" label="Editar Portada" onChange={() => setPortadaChanged(true)}>
            {portadaChanged ? <ImageField source="src" /> : <ImageField source="url" />}
        </FileInput>

        <FileInput source="video" label="Editar Video" onChange={() => setVideoChanged(true)}>
            {videoChanged ? <ImageField source="src" /> : <ImageField source="url" />}
        </FileInput>
      </SimpleForm>
    </Edit>
  );
}

export default TarjetasInicioEdit;